<div class="grid flex-column-reverse sm:flex-row xl:flex xl:flex-row" [ngClass]="{
    'overflow-hidden': showMessageCenter
}">
    <div class="col-12" *ngIf="myBuchung && myBuchung.length > 0">
        <mat-accordion *ngIf="myTabStateService.TabStates$ | async as TabStates">
            <mat-expansion-panel
                    class="mat-elevation-z0"
                    hideToggle
                    (opened)="onTabOpen('z5')"
                    (closed)="onTabClose('z5')"
                    [expanded]="TabStates?.z5 == null || TabStates?.z5 == true">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="flex justify-content-between align-items-center w-100">
                            <div class="flex space-x-2">
                                <div class="ml-1">
                                    <div class="transition-all rotate-0 {{ TabStates.z5 ? 'rotate-90' : '' }}">
                                        <fa-icon icon="chevron-right"></fa-icon>
                                    </div>
                                </div>
                                <div class="text-xl font-bold">
                                    {{ 'txZeitKonto.timeSumsChart' | translate }}
                                </div>
                            </div>
                            <div class="my-3">
                                <div *ngIf="reports$ | async as reports">
                                    <button
                                            mat-icon-button
                                            class="tx-pdf-button"
                                            type="button"
                                            [disabled]="loadingReport"
                                            (click)="stopPropagation($event)"
                                            [matMenuTriggerFor]="reportMenu">
                                        <fa-icon *ngIf="!loadingReport" icon="file-pdf" class="large-icon"></fa-icon>
                                        <fa-icon *ngIf="loadingReport" icon="spinner" class="large-icon" [spin]="true"
                                                 disabled></fa-icon>
                                    </button>
                                    <mat-menu #reportMenu="matMenu">
                                        <button *ngFor="let report of reports" (click)="downloadReport(report)"
                                                mat-menu-item>
                                            {{ report.report_name }}
                                        </button>
                                    </mat-menu>
                                </div>
                            </div>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <tx-time-sums-chart *ngIf="TabStates?.z5"></tx-time-sums-chart>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <div class="col-12 xl:flex-1 xl:min-w-0">
        <mat-accordion *ngIf="myTabStateService.TabStates$ | async as TabStates">
            <mat-expansion-panel
                    class="mat-elevation-z0"
                    hideToggle
                    (opened)="onTabOpen('z3')"
                    (closed)="onTabClose('z3')"
                    [expanded]="TabStates?.z3 == null || TabStates?.z3 == true">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="flex space-x-2">
                            <div class="ml-1">
                                <div class="transition-all rotate-0 {{ TabStates.z3 ? 'rotate-90' : '' }}">
                                    <fa-icon icon="chevron-right"></fa-icon>
                                </div>
                            </div>
                            <div class="text-xl font-bold">
                                {{ 'txZeitKonto.bookings' | translate }}
                            </div>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <div class="w-full overflow-x-auto overflow-y-hidden whitespace-nowrap border-1 rounded">
                        <div class="table-scroll" style="--tscroll-min: 1400px">
                        <table class="full-width min-w-[700px]" mat-table [dataSource]="dataSource" matSort
                               matSortActive="Datum"
                               matSortDirection="desc">

                            <!-- Date Column -->
                            <ng-container matColumnDef="Datum">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-weight-bold text-base"
                                    style="min-width: 100px">{{ 'txZeitKonto.date' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let item" [class.weekend]="isWeekend(item.Datum)"
                                    (click)="buchungsDate = item.Datum">
                                    <a [routerLink]="['/kalender', { date: item.Datum }]">
                                        {{ weekdayKey(item.Datum) | translate }}. {{ item.Datum | date: 'dd.MM.yyyy' }}
                                    </a>
                                </td>
                            </ng-container>

                            <!-- Begin Column -->
                            <ng-container matColumnDef="beginn">
                                <th mat-header-cell *matHeaderCellDef class="font-weight-bold text-base text-center"
                                    style="min-width: 80px">{{ 'txZeitKonto.begin' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let item" [class.weekend]="isWeekend(item.Datum)" class="text-center">
                                    {{ item.beginnart }} {{ item.beginn | coTime }}
                                </td>
                            </ng-container>

                            <!-- End Column -->
                            <ng-container matColumnDef="ende">
                                <th mat-header-cell *matHeaderCellDef class="font-weight-bold text-base text-center"
                                    style="min-width: 80px">{{ 'txZeitKonto.end' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let item" [class.weekend]="isWeekend(item.Datum)" class="text-center">
                                    {{ item.endeart }} {{ item?.ende | coTime }}
                                </td>
                            </ng-container>

                            <!-- Debit Column -->
                            <ng-container matColumnDef="soll">
                                <th mat-header-cell *matHeaderCellDef
                                    class="font-weight-bold text-base text-right pr-4">{{ 'txZeitKonto.debit' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let item" [class.weekend]="isWeekend(item.Datum)" class="text-right pr-4">
                                    {{ item.soll }}
                                </td>
                            </ng-container>

                            <!-- Diff Column -->
                            <ng-container matColumnDef="Diff">
                                <th mat-header-cell *matHeaderCellDef
                                    class="font-weight-bold text-base text-right pr-4">
                                    <fa-icon icon="chevron-left" class="me-1"></fa-icon>
                                    {{ 'txZeitKonto.diff' | translate }}
                                    <fa-icon icon="chevron-right" class="ms-1"></fa-icon>
                                </th>
                                <td mat-cell *matCellDef="let item" [class.weekend]="isWeekend(item.Datum)" class="text-right pr-4"
                                    [style.color]="isNegative(item.Diff)">
                                    {{ item.Diff }}
                                </td>
                            </ng-container>

                            <!-- Ist Column -->
                            <ng-container matColumnDef="Summe">
                                <th mat-header-cell *matHeaderCellDef
                                    class="font-weight-bold text-base text-right pr-4">{{ 'txZeitKonto.ist' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let item" [class.weekend]="isWeekend(item.Datum)" class="text-right pr-4">
                                    {{ item.Summe }}
                                </td>
                            </ng-container>

                            <!-- BDE Diff Column - nur anzeigen wenn shouldShowBdeColumns true ist -->
                            <ng-container matColumnDef="bde_diff">
                                <th mat-header-cell *matHeaderCellDef
                                    class="font-weight-bold text-base text-right pr-4">
                                    <fa-icon icon="chevron-left" class="me-1"></fa-icon>
                                    {{ 'txZeitKonto.diff' | translate }}
                                    <fa-icon icon="chevron-right" class="ms-1"></fa-icon>
                                </th>
                                <td mat-cell *matCellDef="let item" [class.weekend]="isWeekend(item.Datum)" class="text-right pr-4"
                                    [style.color]="isNegative(item.bde_diff)">
                                    {{ item.bde_diff }}
                                </td>
                            </ng-container>

                            <!-- BDE Sum Column - nur anzeigen wenn shouldShowBdeColumns true ist -->
                            <ng-container matColumnDef="bde_sum">
                                <th mat-header-cell class="font-weight-bold text-base text-right pr-4"
                                    *matHeaderCellDef>{{ 'txZeitKonto.sum' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let item" [class.weekend]="isWeekend(item.Datum)" class="text-right pr-4">
                                    {{ item.bde_sum }}
                                </td>
                            </ng-container>

                            <!-- DailyInfo Column -->
                            <ng-container matColumnDef="Tagesinfo">
                                <th mat-header-cell *matHeaderCellDef class="font-weight-bold text-base"
                                    style="padding-right: 0 !important;">
                                    {{ 'txZeitKonto.dailyInfo' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let item" [class.weekend]="isWeekend(item.Datum)"
                                    [style.backgroundColor]="item.FehlzeitFarbe" style="padding-right: 0 !important;" class="text-center">
                                    {{ item.Tagesinfo }}
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                        </div>
                    </div>

                    <mat-paginator [pageSizeOptions]="[15, 25, 50, 100]" [pageSize]="15"
                                   showFirstLastButtons></mat-paginator>
                </div>
            </mat-expansion-panel>
        </mat-accordion>

        <div class="mt-3" *ngIf="hasEmployeeDocuments">
            <mat-accordion *ngIf="myTabStateService.TabStates$ | async as TabStates">
                <mat-expansion-panel
                        class="mat-elevation-z0"
                        hideToggle
                        (opened)="onTabOpen('z4')"
                        (closed)="onTabClose('z4')"
                        [expanded]="TabStates?.z4 == null || TabStates?.z4 == true">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <div class="flex space-x-2">
                                <div class="ml-1">
                                    <div class="transition-all rotate-0 {{ TabStates.z4 ? 'rotate-90' : '' }}">
                                        <fa-icon icon="chevron-right"></fa-icon>
                                    </div>
                                </div>
                                <div class="text-xl font-bold">
                                    {{ 'txZeitKonto.personalFile' | translate }}
                                </div>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                        <div class="w-full overflow-x-auto overflow-y-hidden whitespace-nowrap border-1 rounded">
                            <div class="table-scroll" style="--tscroll-min: 1400px">
                            <table mat-table [dataSource]="employeeDocuments" class="full-width" id="documentsTable">
                                <!-- Document Name Column -->
                                <ng-container matColumnDef="document_name">
                                    <th mat-header-cell *matHeaderCellDef class="font-weight-bold text-base">
                                        {{ 'txZeitKonto.documentName' | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let document">{{ document.document_name }}</td>
                                </ng-container>

                                <!-- Description Column -->
                                <ng-container matColumnDef="document_description">
                                    <th mat-header-cell *matHeaderCellDef class="font-weight-bold text-base">
                                        {{ 'txZeitKonto.description' | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let document">{{ document.document_description }}</td>
                                </ng-container>

                                <!-- Date Column -->
                                <ng-container matColumnDef="document_date">
                                    <th mat-header-cell *matHeaderCellDef class="font-weight-bold text-base">
                                        {{ 'txZeitKonto.documentDate' | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let document">{{ document.document_date | date: 'dd.MM.yyyy' }}</td>
                                </ng-container>

                                <!-- Download Action Column -->
                                <ng-container matColumnDef="actions">
                                    <th mat-header-cell *matHeaderCellDef class="font-weight-bold text-base text-center">
                                        {{ 'txZeitKonto.actions' | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let document" class="text-center">
                                        <button
                                                mat-icon-button
                                                color="primary"
                                                [disabled]="document.loading"
                                                (click)="sendEmployeeDocument(document)"
                                                [matTooltip]="'txZeitKonto.downloadDocument' | translate">
                                            <fa-icon *ngIf="!document.loading" icon="download"></fa-icon>
                                            <fa-icon *ngIf="document.loading" icon="spinner" [spin]="true"></fa-icon>
                                        </button>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="['document_name', 'document_description', 'document_date', 'actions']"></tr>
                                <tr mat-row *matRowDef="let row; columns: ['document_name', 'document_description', 'document_date', 'actions'];"></tr>
                            </table>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>

    <div class="col-12 xl:col-3 min-w-[400px]">
        <div class="mb-3">
            <mat-accordion *ngIf="myTabStateService.TabStates$ | async as TabStates">
                <mat-expansion-panel
                        class="mat-elevation-z0"
                        hideToggle
                        (opened)="onTabOpen('z1')"
                        (closed)="onTabClose('z1')"
                        [expanded]="TabStates?.z1 == null || TabStates?.z1 == true">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <div class="flex space-x-2">
                                <div class="ml-1">
                                    <div class="transition-all rotate-0 {{ TabStates.z1 ? 'rotate-90' : '' }}">
                                        <fa-icon icon="chevron-right"></fa-icon>
                                    </div>
                                </div>
                                <div class="text-xl font-bold">
                                    {{ 'txZeitKonto.balances' | translate }}
                                </div>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="w-full overflow-y-hidden whitespace-nowrap border-1 rounded">
                        <div class="table-scroll" style="--tscroll-min: 1400px">
                        <table mat-table [dataSource]="myInfo" class="full-width" id="balancesTable">
                            <!-- Account Column -->
                            <ng-container matColumnDef="account">
                                <th mat-header-cell *matHeaderCellDef
                                    class="font-weight-bold text-base">
                                    {{ 'txZeitKonto.account' | translate }}
                                </th>
                                    <td mat-cell *matCellDef="let item">{{ item.konto }}</td>
                                </ng-container>

                            <!-- Balance Column -->
                            <ng-container matColumnDef="balance">
                                <th mat-header-cell *matHeaderCellDef
                                    class="font-weight-bold text-base text-right">
                                    {{ 'txZeitKonto.balance' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let item" class="text-right" [innerHTML]="item.wert"></td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="['account', 'balance']"></tr>
                            <tr mat-row *matRowDef="let row; columns: ['account', 'balance'];"></tr>
                        </table>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <div class="mb-3" *ngIf="myAuthService?.getSession()?.Workflow == 1">
            <mat-accordion
                    *ngIf="myTabStateService.TabStates$ | async as TabStates">
                <mat-expansion-panel
                        class="mat-elevation-z0"
                        hideToggle
                        (opened)="onTabOpen('z2')"
                        (closed)="onTabClose('z2')"
                        [expanded]="TabStates?.z2 == null || TabStates?.z2 == true">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <div class="flex space-x-2">
                                <div class="ml-1">
                                    <div class="transition-all rotate-0 {{ TabStates.z2 ? 'rotate-90' : '' }}">
                                        <fa-icon icon="chevron-right"></fa-icon>
                                    </div>
                                </div>
                                <div class="text-xl font-bold">
                                    {{ 'txZeitKonto.requestBookings' | translate }}
                                </div>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                        <tx-apply-booking [myFormType]="buchungForm" [myBuchungsDate]="buchungsDate"></tx-apply-booking>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <div *ngIf="userPermissions$ | async as Permissions">
            <div *ngIf="hasPermission(Permissions, has_message_center)">
                <div *ngTemplateOutlet="msgCenter"></div>
            </div>
        </div>
    </div>
</div>

<ng-template #msgCenter>
    <mat-accordion
            *ngIf="myTabStateService.TabStates$ | async as TabStates">
        <mat-expansion-panel
                class="mat-elevation-z0"
                hideToggle
                (opened)="onTabOpen('z6')"
                (closed)="onTabClose('z6')"
                [expanded]="TabStates?.z6 == null || TabStates?.z6 == true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <div class="flex space-x-2">
                        <div class="ml-1">
                            <div class="transition-all rotate-0 {{ TabStates.z6 ? 'rotate-90' : '' }}">
                                <fa-icon icon="chevron-right"></fa-icon>
                            </div>
                        </div>
                        <div class="text-xl font-bold">
                            {{ 'txZeitKonto.messageCenter' | translate }}
                        </div>
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
                <tx-messagecenter-client [fullHeight]="showMessageCenter"></tx-messagecenter-client>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</ng-template>
